import * as global from './global';
import * as alert from './alert';
import * as auth from './auth';
import * as profile from './profile';
import * as create from './create';
import * as teams from './teams';
import * as users from './users';
import * as agreements from './agreements';
import * as deals from './deals';
import * as works from './works';
import * as workOwnerships from './workOwnerships';
import * as invites from './invites';
import * as dealBlocks from './dealBlocks';
import * as dealMessages from './dealMessages';
import * as dealUsers from './dealUsers';
import * as coreg from './coreg';
import * as payment from './payment';

export default {
  ...global,
  ...alert,
  ...auth,
  ...profile,
  ...teams,
  ...users,
  ...create,
  ...agreements,
  ...deals,
  ...works,
  ...workOwnerships,
  ...invites,
  ...dealBlocks,
  ...dealMessages,
  ...dealUsers,
  ...coreg,
  ...payment,
};



// WEBPACK FOOTER //
// src/redux/actions/index.js